<template>
    <div class="flex items-center justify-center w-full">
        <div class="flex flex-col gap-4 w-full max-w-[500px]">
            <h1 class="text-2xl font-bold">Login</h1>
            <form @submit.prevent="submit" class="flex flex-col gap-4">
                <fwb-input v-model="form.username" class="w-full" placeholder="username" label="Username" type="email" name="username" />
                <fwb-input v-model="form.password" class="w-full" placeholder="password" label="Password" type="password" name="password" />
                <div class="flex items-center gap-4 h-10 w-full [&>*>*]:w-full [&>*>*]:h-full">
                    <!-- <fwb-button class="w-full h-full" color="alternative" disabled>Forgot Password</fwb-button> -->
                    <fwb-button type="submit" class="w-full h-full" color="default">Login</fwb-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { FwbInput, FwbButton } from 'flowbite-vue'

const form = useForm({
    username: '',
    password: ''
})

function submit() {
    form.post('/users/login')
}
</script>